export default "__VITE_ASSET__SPEKdwoi__"